var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIsologo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 1080",
    style: {
      enableBackground: "new 0 0 1920 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFF100;}\n\t.st1{fill:#94CFDC;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1097,791.1L941.9,656.5c-16.2-15.8-37.4-24.5-60.1-24.5c-22.6-0.1-43.9,8.5-60.2,24.2L664.9,791 c-14.9,12.8-16.5,35.2-3.8,50c12.8,14.9,35.2,16.5,50,3.8l157.7-135.5c0.7-0.6,1.3-1.2,2-1.8c3.9-3.9,8.5-4.5,10.9-4.5 c2.4,0,7,0.6,10.9,4.6c0.6,0.6,1.3,1.2,1.9,1.8l156,135.3c14.8,12.8,37.2,11.2,50-3.5c5.8-6.7,8.7-15,8.7-23.2 C1109.3,808,1105.1,798.1,1097,791.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1263.5,239c-12.8-14.9-35.2-16.5-50-3.8L893,538.4c-0.7,0.6-1.3,1.2-2,1.8c-3.9,3.9-8.5,4.5-10.9,4.5 c-2.4,0-7-0.6-10.9-4.6c-0.6-0.6-1.3-1.2-1.9-1.8L706.7,399c-14.8-12.8-37.2-11.2-50,3.5c-12.8,14.8-11.2,37.2,3.5,50l159.8,138.6 c16.2,15.8,37.4,24.5,60.1,24.5c22.6,0.1,43.9-8.5,60.2-24.2L1259.7,289c8.2-7,12.3-16.9,12.3-26.9 C1272,253.9,1269.2,245.6,1263.5,239z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsologo);
export default __webpack_public_path__ + "static/media/isologo.3a621b30983dc02c824f547916d8c6a4.svg";
export { ForwardRef as ReactComponent };